import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { _Api } from '../api/_call';
import { SetdataTable, UnSetdataTable } from '../api/setdatatable';
import TableColumnModal from '../common/modules/tableColumn';
import { Tablehead } from '../common/modules/Tablehead';
import 'datatables.net-dt';
import 'datatables.net-fixedcolumns';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { itemsearchtableHead } from '../common/Tablehead';
import FileExport from '../common/fileexport';
import { error } from '../common/helpers/toastify';
import SocialModal from '../common/modules/SocialModal/SocialModal';
import { useTranslation } from 'react-i18next';
import TableLoader from '../../admin/common/TableLoader';
import catalogIcon from "../../assets/images/catalog-icon.png"
import invIcon from "../../assets/images/inv-icon.png"
import product_design from "../../assets/images/product_design.svg";
import chain_origin from "../../assets/images/chain_origin.svg";
import diamond_mine from "../../assets/images/diamond_mine.svg";
import metal_origin from "../../assets/images/metal_origin.svg";
import handcrafting from "../../assets/images/handcrafting.svg";
import qc_shipping from "../../assets/images/qc_shipping.svg";
import chainrelated from "../../assets/images/chainrelated.png";
import diamondrelated from "../../assets/images/diamondrelated.png";
import TraceabilityModal from "./TraceabilityModal";
import traceimg from "../../assets/images/TraceItem_diamond.svg";
import { useSelector } from "react-redux";
import item_search_disable_pos from "../../assets/images/item_search_disable_pos.png"
import item_search_pos from "../../assets/images/item_search_pos.png"
import item_search_disable_reserve from "../../assets/images/item_search_disable_reserve.png"
import item_search_reserve from "../../assets/images/item_search_reserve.png"
import item_search_disable_transfer from "../../assets/images/item_search_disable_transfer.png"
import item_search_transfer from "../../assets/images/item_search_transfer.png"
import item_search_transaction from "../../assets/images/item_search_transaction.png"
import item_search_quickview from "../../assets/images/item_search_quickview.png"
import allocatableimg from "../../assets/images/allocatable-1.svg";
const ItemSearch = (props) => {
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const traceabilityEnabled = generalsettings?.data?.generalsetup?.traceability === "1";
  const { t } = useTranslation()
  const [settings, setSetting] = useState()
  const [, setfilterby] = useState('')
  const [searchvalue, setSearchvalue] = useState()
  const [searchlist, setSearchlist] = useState('')
  const [transactionsku, setTransactionsku] = useState()
  const [transactionstockid, setTransactionstockid] = useState("")
  const [show, setShow] = useState(false)
  const [getsearchcontent, setGetsearchcontent] = useState()
  const [searchdetail, setSearchdetail] = useState([])
  const [detail, setDetail] = useState()
  const [selectedlocation, setSelectedlocation] = useState()
  const [selecteditems, setSelecteditems] = useState([])
  const [newcolumndata, setnewcolumndata] = useState(itemsearchtableHead)
  const [datalodaer, setDatsLodaer] = useState(false)
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [mode, setMode] = useState("SKU");
  const [traceData, setTraceData] = useState();
  const [traceDetail, setTraceDetail] = useState({});

  const debounceTimer = useRef(null);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const iconMap = {
    "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
    "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
    "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
    "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
    "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
    "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
  };

  const getTimelineData = (data) => {
    const timeline = [];

    // 1. Add product design at top
    timeline.push({
      id: "product_design",
      name: "Product Design",
      countries: [data?.product_design_trace ? data?.product_design_trace : []],
      transactionId: data?.product_design_trace_detail?.transactionId || "-",
      iconName: { icon: product_design, color: "#3C609C" },
    });

    // 2. Add traceability items sorted by iconMap order (reverse order)
    const iconMapOrder = [
      "652e2c3f7ab8c5b2750a4f03",
      "652e2c3f7ab8c5b2750a4f04",
      "652e2c3f7ab8c5b2750a4f05",
      "652e2c3f7ab8c5b2750a4f08",
      "652e2c3f7ab8c5b2750a4f09",
      "652e2c3f7ab8c5b2750a4f06",
      "652e2c3f7ab8c5b2750a4f07",
      "652e2c3f7ab8c5b2750a4f0a",
      "652e2c3f7ab8c5b2750a4f0b",
      "652e2c3f7ab8c5b2750a4f0c",
      "652e2c3f7ab8c5b2750a4f02",
    ];

    // Items in the defined order
    const orderedItems = iconMapOrder
      .filter((key) => data.traceability[key])
      .map((key) => ({
        id: key,
        ...data.traceability[key],
        iconName: iconMap[key]
          ? iconMap[key]
          : {
            icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
            color: "#606060",
          },
      }));

    // Items not in iconMapOrder (put at last)
    const unorderedItems = Object.keys(data.traceability)
      .filter((key) => !iconMapOrder.includes(key))
      .map((key) => ({
        id: key,
        ...data.traceability[key],
        iconName: iconMap[key]
          ? iconMap[key]
          : {
            icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
            color: "#606060",
          },
      }));

    timeline.push(...orderedItems, ...unorderedItems);
    return timeline;
  };
  const selectlocation = (event) => {
    const mainarray = [...searchdetail]
    if (event.target.checked) {
      const currentid = mainarray.filter((all) => {
        return all.location_id === event.target.id
      })
      setSelectedlocation(currentid[0]?.location_id)
      mainarray.forEach((result, key) => {
        if (result?.location_id !== currentid[0]?.location_id) {
          mainarray[key] = {
            ...mainarray[key],
            'checkboxclass': true,
          }
        } else {
          mainarray[key] = {
            ...mainarray[key],
            'checkboxclass': false,
          }
        }
      })
      setSearchdetail(mainarray)
      setSelecteditems(currentid[0].ids)
    } else {
      mainarray.forEach((result, key) => {
        mainarray[key] = {
          ...mainarray[key],
          'checkboxclass': false,
        }
      })
      setSearchdetail(mainarray)
      setSelecteditems([])
      setSelectedlocation('')
    }
  }
  const getsearchvalue = (value) => {
    setSearchvalue(value)
    setShow(false)
    callsearchdetails(value)
  }
  const callsearchlist = async (event) => {
    // let type = ''
    // let typeforsearch = document.querySelectorAll('.typeforsearch')
    // for (let i = 0; i < typeforsearch.length; i++) {
    //   if (typeforsearch[i].checked) {
    //     type = typeforsearch[i].value
    //   }
    // }
    try {
      const postdata = {
        search: event.target.value,
        type: mode,
      }
      let resSearchlist = await _Api(
        postdata,
        `api/v1/inventory/my/itemKeySearch`,
      )
      if (resSearchlist.code === 200) {
        setSearchlist(resSearchlist.data)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const handleKeyNavigation = (e) => {
    if (!searchlist || searchlist.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % searchlist.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev <= 0 ? searchlist.length - 1 : prev - 1
      );
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const selected = searchlist[highlightedIndex];
      if (selected) {
        const selectedSearchKey = selected?.search_key || '';
        setSearchvalue(selectedSearchKey);
        setShow(false);
        setGetsearchcontent(selectedSearchKey)
        callsearchdetails(selectedSearchKey); // ✅ call your API here
        setHighlightedIndex(-1);
      }
    } else if (e.key === 'Escape') {
      setShow(false);
      setHighlightedIndex(-1);
    }
  };


  const callsearchdetails = async (searchkey) => {
    // let type = ''
    // let typeforsearch = document.querySelectorAll('.typeforsearch')
    // for (let i = 0; i < typeforsearch.length; i++) {
    //   if (typeforsearch[i].checked) {
    //     type = typeforsearch[i].value
    //   }
    // }
    console.log(searchkey)
    UnSetdataTable('item_search_table')
    try {
      setDatsLodaer(true)
      const postdata = {
        search: searchkey,
        type: mode,
      }
      let resSearchdata = await _Api(
        postdata,
        `api/v1/inventory/my/itemSearchData`,
      )
      if (resSearchdata.code === 200) {
        setDatsLodaer(false)
        SetdataTable('item_search_table', '0', newcolumndata, [0])
        setSearchdetail(resSearchdata?.data?.item_searchRow)
        setDetail(resSearchdata?.data)
        setTransactionsku(resSearchdata?.data?.SKU)
        let stock_id_name = ""
        if (mode === "stock_id") {
          stock_id_name = searchkey
          const tracesDetail = {
            image: resSearchdata?.data?.images?.[0] || "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
            SKU: resSearchdata?.data?.SKU,
            name: resSearchdata?.data?.name,
            po_QTY: resSearchdata?.data?.final_qty || 0,
            stock_id: stock_id_name || "-",
            transactionId: resSearchdata?.data?.product_design_trace_detail?.transactionId
          }
          setTraceDetail(tracesDetail)
          const traceability = resSearchdata?.data?.traceability || null;
          const product_design_trace = resSearchdata?.data?.product_design_trace || null;
          const product_design_trace_detail = resSearchdata?.data?.product_design_trace_detail
          const traceObj = {
            traceability,
            product_design_trace,
            product_design_trace_detail
          }
          const tracearr = getTimelineData(traceObj);
          setTraceData(tracearr);
        }


      } else {
        SetdataTable('item_search_table', '0', newcolumndata, [0])
        error(t('Something Went Wrong!!'))
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchvalue(value);
    setShow(true);
    setHighlightedIndex(-1);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      callsearchlist({ target: { value } }); // manually wrap the value
    }, 500); // 1000ms debounce
  };
  const callcolumns = async () => {
    try {
      const postdata = {
        name: 'tbl_inventory_itemsearch',
      }
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      )
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    callcolumns()
  }, [])
  useEffect(() => {
    let typeforsearch = document.querySelectorAll('.typeforsearch')
    typeforsearch[1].checked = true
    setSetting({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    })
  }, [])

  useEffect(() => {
    SetdataTable('item_search_table', '0', newcolumndata, [0])
  }, [newcolumndata])

  return (
    <React.Fragment>
      <div className="main-body">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="item-search-wrap">
                <div className="item-search-wrap-left">
                  <h1 className="main-body-heading">{t('Item Search')}</h1>

                  <div className="item-search-wrap-left-box">
                    <div className="main-body-top-status-bar" style={{ marginTop: "0", marginBottom: "1vw" }}>

                      <div className="main-body-top-tab-bar-right-col">
                        <Link
                          to="/app/inventory/createTransfer"
                          state={{
                            createlist: selecteditems,
                            Voucher_id: '',
                            hidelocationid: selectedlocation,
                            showwarehouseid: 'null',
                            ItemSearch: true
                          }}
                          className={
                            selecteditems?.length
                              ? 'main-body-top-tab-bar-right-col-a'
                              : 'main-body-top-tab-bar-right-col-a row-inactive'
                          }
                        >
                          <img
                            // src={base_assets + 'images/icons/cube-bar-icon.png'}
                            src={item_search_transfer}
                            alt=""
                          />
                          <span className="main-body-top-tab-bar-right-col-a-text">
                            {t('transfer')}
                          </span>
                        </Link>
                        <Link
                          to="/app/inventory/posorder"
                          state={{ selectedid: selecteditems }}
                          className={
                            selecteditems?.length
                              ? 'main-body-top-tab-bar-right-col-a'
                              : 'main-body-top-tab-bar-right-col-a row-inactive'
                          }
                        >
                          <img
                            // src={
                            //   base_assets +
                            //   'images/icons/danger-calender-icon.png'
                            // }
                            src={item_search_pos}
                            alt=""
                          />
                          <span className="main-body-top-tab-bar-right-col-a-text">
                            {t('order')}
                          </span>
                        </Link>
                        <Link
                          to="/app/inventory/createreserves"
                          state={{ datalist: selecteditems }}
                          className={
                            selecteditems?.length
                              ? 'main-body-top-tab-bar-right-col-a'
                              : 'main-body-top-tab-bar-right-col-a row-inactive'
                          }
                        >
                          <img
                            // src={
                            //   base_assets +
                            //   'images/icons/yellow-calender-icon.png'
                            // }
                            src={
                              item_search_reserve
                            }
                            alt=""
                          />
                          <span className="main-body-top-tab-bar-right-col-a-text">
                            {t('reserve')}
                          </span>
                        </Link>
                        <Link
                          to="/app/inventory/quickview"
                          className={
                            getsearchcontent
                              ? 'main-body-top-tab-bar-right-col-a'
                              : 'main-body-top-tab-bar-right-col-a row-inactive'
                          }
                          state={{
                            SKU: transactionsku,
                          }}
                          style={{ boxShadow: "none" }}
                        >
                          <img
                            className="img-360"
                            // src={base_assets + 'images/icons/360-view-icon.png'}
                            src={item_search_quickview}
                            alt=""
                          />
                        </Link>
                        <Link
                          to="/app/inventory/transactionHistory"
                          className={
                            getsearchcontent
                              ? 'main-body-top-tab-bar-right-col-a'
                              : 'main-body-top-tab-bar-right-col-a row-inactive'
                          }
                          state={{
                            status: 'All Transcation',
                            location_id: '',
                            SKU: transactionsku,
                            Stock_id: transactionstockid
                          }}
                          style={{ boxShadow: "none" }}
                        >
                          <img
                            // src={
                            //   base_assets + 'images/icons/history-search-icon.png'
                            // }
                            src={item_search_transaction}
                            alt=""
                          />
                        </Link>
                        {traceabilityEnabled && <div className={
                          mode === "stock_id"
                            ? 'main-body-top-tab-bar-right-col-a'
                            : 'main-body-top-tab-bar-right-col-a row-inactive'

                        }
                          style={{ boxShadow: "none" }}
                        >

                          <img
                            src={traceimg}
                            alt="trace_on"
                            data-bs-toggle="modal"
                            data-bs-target="#TraceabilityModal"
                          />


                        </div>}

                        <button className="print-export-dropdown-selected-icon d-none">
                          <img
                            src={base_assets + 'images/icons/printer-icon.png'}
                            alt=""
                          />
                        </button>
                        <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                          <button
                            className="btn dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={
                                base_assets + 'images/icons/ellipsis-circular.png'
                              }
                              alt=""
                            />
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li className="dropdown-item print-dropdown-item">
                              <div className="dropdown-item-img">
                                <img
                                  src={
                                    base_assets + 'images/icons/printer-icon.png'
                                  }
                                  alt=""
                                />
                              </div>
                              <span>{t('print')}</span>
                            </li>
                            <li className="dropdown-item">
                              <div className="dropdown-item-img">
                                <img
                                  src={
                                    base_assets + 'images/icons/export-x-icon.png'
                                  }
                                  alt=""
                                />
                              </div>
                              <FileExport />
                            </li>
                            <li className="dropdown-item">
                              <div className="dropdown-item-img">
                                <img
                                  src={
                                    base_assets + 'images/icons/share-icon.png'
                                  }
                                  alt=""
                                />
                              </div>
                              <span
                                data-bs-toggle="modal"
                                data-bs-target="#socialModal"
                              >
                                {t('share')}
                              </span>
                            </li>
                            <li
                              className="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#columnModal"
                            >
                              <div className="dropdown-item-img">
                                <img
                                  src={
                                    base_assets + 'images/icons/column-icon.png'
                                  }
                                  alt=""
                                />
                              </div>
                              <span>{t('column')}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="main-body-top-status-bar-filter1">
                          <input
                            type="text"
                            value={searchvalue ? searchvalue : ""}
                            className="main-body-top-status-bar-filter1-input position-relative border-start-0"
                            placeholder={t('StockID/SKU')}
                            onChange={(e) => {
                              setSearchvalue(e.target.value)
                              setShow(true)
                              // callsearchlist(e)
                              handleSearchChange(e)
                              setHighlightedIndex(-1);
                            }}
                            onKeyDown={(e) => handleKeyNavigation(e)}
                          />
                          {searchvalue ? <img className="main-body-top-status-bar-filter1-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => setSearchvalue("")} alt="" /> : ""}
                          <button className="main-body-top-status-bar-filter-search">
                            <i className="fa fa-search" aria-hidden="true" />
                          </button>
                          {show && searchvalue !== '' && searchlist.length > 0 ? (
                            <div className="item_list_card_all">
                              <div className="item_list_card">
                                <div className="custom_search_title text-green">
                                  {t('Custom Search')}
                                </div>
                                <ul
                                  id="item_list_cardul_custom"
                                  className="item_list_cardul_custom"
                                >
                                  <li>{searchvalue}</li>
                                </ul>
                                <div className="custom_search_title text-green">
                                  {t('Product')}
                                </div>

                                <ul className="item_list_cardul">
                                  {searchlist
                                    ? searchlist.map((result, key) => {
                                      return (
                                        <li
                                          data-search={
                                            result?.search_key
                                              ? result?.search_key
                                              : ''
                                          }
                                          className={`pos-search-result-item ${key === highlightedIndex ? 'focused' : ''}`}
                                          onClick={(e) => {
                                            getsearchvalue(result?.search_key);
                                            setGetsearchcontent(result?.search_key || '');
                                            if (result?.SKU) {
                                              setTransactionstockid(result?.search_key);
                                            } else {
                                              setTransactionstockid(result?.search_key);
                                            }
                                            setShow(false);
                                            // setSearchvalue(result?.search_key);
                                            setHighlightedIndex(-1);
                                          }}
                                          key={key}
                                        >
                                          <div className="pos-search-result-thumb">
                                            {result?.main_image ? (
                                              <img
                                                src={result.main_image}
                                                alt=""
                                                onError={(e) => {
                                                  e.target.onerror = null; // prevent infinite loop
                                                  e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                                }}
                                              />
                                            ) : null}
                                          </div>
                                          <div className="pos-search-result-text">
                                            <div className="pos-search-result-name">
                                              {result?.name}
                                            </div>
                                            <div className="pos-search-result-meta">
                                              {result?.SKU
                                                ? `${result?.SKU} (${result?.search_key})`
                                                : result?.search_key}
                                            </div>
                                          </div>
                                        </li>
                                      )
                                    })
                                    : ''}
                                </ul>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                        <div style={{ display: "flex", backgroundColor: "#f2f2f2", borderRadius: "4px" }}>
                          <div className="item-search-wrap-left-radio1">
                            <div className="item-search-wrap-left-radio1-single"
                              style={mode === "stock_id" ? { background: "#fff" } : { background: "none" }}>
                              <div className="com-check radio">
                                <input
                                  type="radio"
                                  id="f1"
                                  value="stock_id"
                                  className="typeforsearch d-none"
                                  name="itemRadio"
                                  checked={mode === "stock_id"}
                                  style={{ display: "none" }}
                                />
                                {/* <label
                              className="com-check-label"
                              htmlFor="f1"
                            ></label> */}
                              </div>
                              <label
                                className="item-search-wrap-left-radio1-single-label"
                                htmlFor="f1"
                                onClick={() => setMode("stock_id")}
                              >
                                <img
                                  className="item-search-wrap-left-radio1-single-label-img"
                                  src={
                                    // base_assets + 'images/icons/stock-id-Icon.png'
                                    invIcon
                                  }
                                  alt=""

                                />

                              </label>
                            </div>
                            <div className="item-search-wrap-left-radio1-single"
                              style={mode === "SKU" ? { background: "#fff" } : { background: "none" }}
                            >
                              <div className="com-check radio">
                                <input
                                  type="radio"
                                  value="SKU"
                                  id="f2"
                                  className="typeforsearch d-none"
                                  name="itemRadio"
                                  checked={mode === "SKU"}
                                  style={{ display: "none" }}
                                />
                                {/* <label
                              className="com-check-label"
                              htmlFor="f2"
                            ></label> */}
                              </div>
                              <label
                                className={`item-search-wrap-left-radio1-single-label`}
                                htmlFor="f2"
                                onClick={() => {
                                  setMode("SKU");
                                  setTraceData();
                                  setTraceDetail();
                                }}
                              >
                                <img
                                  className="item-search-wrap-left-radio1-single-label-img"
                                  // src={base_assets + 'images/icons/sku-icon.png'}
                                  src={catalogIcon}
                                  alt=""

                                />
                                {/* {t('SKU')} */}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="item-search-wrap-left-box-head">
                      <div className="item-search-wrap-left-box-head-left">
                        <h5 className="item-search-wrap-left-box-head-left-heading">
                          {t('SKU')}:
                          <span>
                            {getsearchcontent
                              ? detail?.SKU
                                ? detail?.SKU
                                : ''
                              : ''}
                          </span>
                        </h5>
                        <p className="item-search-wrap-left-box-head-left-pro-name">
                          {/* #Cleo Diamond Slim Slip-On Bracelet title */}#
                          {getsearchcontent
                            ? detail?.name
                              ? detail?.name
                              : ''
                            : ''}
                        </p>
                      </div>
                      <div className="item-search-wrap-left-box-head-right">
                        <p className="item-search-wrap-left-box-head-right-available">
                          {t('Available')} :
                          <span>
                            {getsearchcontent
                              ? detail?.finalAvailable
                                ? detail?.finalAvailable
                                : '0'
                              : ''}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="main-body-main-table-wrap">
                      <table
                        id="item_search_table"
                        className="common-table product-base-table w-100"
                      >
                        <Tablehead
                          tablehead={itemsearchtableHead}
                          tblName={'tbl_inventory_itemsearch'}
                          setfilterby={setfilterby}
                        />
                        <tbody>
                          <>
                            {getsearchcontent ? searchdetail?.length ? searchdetail.map((result, key) => {
                              return (
                                <tr key={key}>
                                  <td className="pe-0">
                                    <div
                                      className={
                                        parseInt(result?.available) > 0
                                          ? result?.checkboxclass
                                            ? 'com-check checkbox-disabled'
                                            : 'com-check'
                                          : 'com-check checkbox-disabled'
                                      }
                                    >
                                      <input
                                        id={result?.location_id}
                                        data-ids={result?.ids}
                                        onClick={(e) => selectlocation(e)}
                                        type="checkbox"
                                        className="itemsearchtable"
                                      />
                                      <label
                                        htmlFor={result?.location_id}
                                        className="com-check-label"
                                      />
                                    </div>
                                  </td>
                                  <td className="pe-0">{key + 1}</td>
                                  <td className="link-color text-start">
                                    {result?.location
                                      ? result?.location
                                      : '-'}
                                  </td>
                                  <td className="stock-color text-end">
                                    {result?.total_qty
                                      ? result?.total_qty
                                      : '0'}
                                  </td>
                                  <td className="reserved-color text-end">
                                    {parseInt(result?.reserve) > 0 ? (
                                      <Link
                                        className="reserved-color text-decoration-none"
                                        to="/app/inventory/transactionHistory"
                                        state={{
                                          status: 'reserve',
                                          location_id:
                                            result?.location_id,
                                          SKU: transactionsku,
                                          stock_id:transactionstockid
                                        }}
                                      >
                                        {result?.reserve
                                          ? result?.reserve
                                          : '0'}
                                      </Link>
                                    ) : result?.reserve ? (
                                      result?.reserve
                                    ) : (
                                      '0'
                                    )}
                                  </td>
                                  <td className="available-color text-end">
                                    {result?.available
                                      ? result?.available
                                      : '0'}
                                  </td>
                                  <td className="sold-color text-end">
                                    {parseInt(result?.sold) > 0 ? (
                                      <Link
                                        className="sold-color  text-decoration-none"
                                        to="/app/inventory/transactionHistory"
                                        state={{
                                          status: 'sold',
                                          location_id:
                                            result?.location_id,
                                          SKU: transactionsku,
                                          stock_id:transactionstockid
                                        }}
                                      >
                                        {result?.sold
                                          ? result?.sold
                                          : '0'}
                                      </Link>
                                    ) : result?.sold ? (
                                      result?.sold
                                    ) : (
                                      '0'
                                    )}
                                  </td>
                                </tr>
                              )
                            })
                              :
                              ''
                              : ''}
                          </>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              className="main-green-text left-0 col-highlight text-start"
                              colSpan={3}
                            >
                              {selecteditems.length > 0 ? (
                                <span>{t('1 item selected')}</span>
                              ) : (
                                ''
                              )}
                            </td>
                            <td className="col-highlight text-end">
                              {searchdetail?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + parseInt(val.total_qty)),
                                0,
                              )}
                            </td>
                            <td className="col-highlight text-end">
                              {searchdetail?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + parseInt(val.reserve)),
                                0,
                              )}
                            </td>
                            <td className="col-highlight text-end">
                              {searchdetail?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + parseInt(val.available)),
                                0,
                              )}
                            </td>
                            <td className="col-highlight text-end">
                              {searchdetail?.reduce(
                                (interation, val) =>
                                (interation =
                                  interation + parseInt(val.sold)),
                                0,
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      {datalodaer && <TableLoader />}
                    </div>
                  </div>
                </div>
                <div className="item-search-wrap-right">
                  <Slider className="product-slider" {...settings}>
                    {detail?.images ? (
                      detail?.images.map((result, key) => {
                        return (
                          <div key={key}>
                            <img
                              src={
                                getsearchcontent
                                  ? result
                                  : base_assets +
                                  'images/blank-img.png'
                              } alt=""
                            />
                          </div>
                        )
                      })
                    ) : (
                      <div>
                        <img
                          src={
                            base_assets + 'images/blank-img.png'
                          } alt=""
                        />
                      </div>
                    )}
                  </Slider>
                  {getsearchcontent ? (
                    <div className="item-search-wrap-right-item-specification-box">
                      <h5 className="item-search-wrap-right-item-specification-box-name">
                        {detail?.tag ? detail?.tag : ''}
                      </h5>
                      <div className="item-search-wrap-right-item-specification-box-metal">
                        <div className="item-search-wrap-right-item-specification-box-metal-div">
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-1">
                            {t('Metal')}:
                          </span>
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-2">
                            {detail?.metalname ? detail?.metalname : ''}
                          </span>
                        </div>
                        <div className="item-search-wrap-right-item-specification-box-metal-div">
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-1">
                            {t('Stone')} :
                          </span>
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-2">
                            {detail?.stone_name ? detail?.stone_name : ''}
                          </span>
                        </div>
                        <div className="item-search-wrap-right-item-specification-box-metal-div">
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-1">
                            {t('Size')} :
                          </span>
                          <span className="item-search-wrap-right-item-specification-box-metal-div-span-2">
                            {detail?.sizename ? detail?.sizename : ''}
                          </span>
                        </div>
                      </div>
                      <ul className="item-search-wrap-right-item-specification-box-ul">
                        <li className="item-search-wrap-right-item-specification-box-ul-li">
                          {detail?.extra_po_information}
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialModal />
        <div
          className="modal fade common-modal"
          id="createPurchaseModal"
          tabIndex={-1}
          aria-labelledby="createPurchaseModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <img
                  className="common-modal-exclamation-img"
                  src={base_assets + 'images/icons/exclamation-mark-green.png'}
                  alt=""
                />
                <p className="modal-content-text">
                  {t('Are you sure you want to Reserve this item ?')}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn modal-content-no"
                  data-bs-dismiss="modal"
                >
                  {t('No')}
                </button>
                <button type="button" className="btn modal-content-yes">
                  {t('yes')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TraceabilityModal
        t={t}
        traceData={traceData}
        traceDetail={traceDetail}
      />
      <TableColumnModal
        tablehead={itemsearchtableHead}
        tblName={'tbl_inventory_itemsearch'}
        setnewcolumndata={setnewcolumndata}
        calldatatable={callsearchdetails}
      ></TableColumnModal>
    </React.Fragment>
  )
}

export default ItemSearch;
